import { render, staticRenderFns } from "./b5.vue?vue&type=template&id=61458632&scoped=true"
import script from "./b5.vue?vue&type=script&lang=js"
export * from "./b5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61458632",
  null
  
)

export default component.exports